import { Avatar, AvatarSize, emptyFragment } from '@execonline-inc/execonline-ui';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { Link } from '../../../Resource/Types';

interface Props {
  imgLink: Maybe<Link>;
  size: AvatarSize;
  altText: string;
}

function ImageComponent({ imgLink, size, altText }: Props) {
  return imgLink
    .map((img) => (
      <Avatar
        src={img.href}
        className="mr-2 overflow-hidden"
        alt={altText}
        radius="full"
        size={size}
      />
    ))
    .getOrElse(emptyFragment);
}
export default observer(ImageComponent);
